<template>
  <v-container fluid class="superTable pa-0">
    <v-row no-gutters class="justify-space-between">
      <v-col sm="4" class="mt-4 mb-2 d-flex" >
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :placeholder="$t('actions.search')"
          outlined
          clearable
          class="superTable__search"
          @click:clear="search = '';keyup()"
          @keyup="keyup"
          @keyup.esc="search = ''"
        ></v-text-field>
      </v-col>
      <!-- <v-col sm="8" class="mt-4 mb-2">
          <div class="d-flex justify-end">
              <Button
                class="ml-4"
                depressed
                :text="$t('modules.messaging.template.areaTemplates.newMessage')"
                @clicked="newMessage"
              ></Button>
            </div>
      </v-col> -->
    </v-row>
    <v-row no-gutters>
      <v-col sm="12">
        <v-data-table
          :show-select="false"
          :headers="headers"
          :items="data"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :totalItems="totalItems"
          hide-default-footer
          item-key="id"
          class="superTable__table"
          style="table-layout: fixed"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          @update:sort-by="$emit('update:sortBy', Array.isArray($event) ? $event[0] : $event)" 
          @update:sort-desc="$emit('update:sortDesc', Array.isArray($event) ? $event[0] : $event)"
        >
          <template v-slot:[`item.title`]="{ item }">
          <v-list-item-title>{{item.title}}</v-list-item-title>
          <v-list-item-subtitle class="d-flex text-muted">{{item.subtitle}}</v-list-item-subtitle>
        </template>
         <template v-slot:[`item.status`]="{item}">
            <v-icon size="12" :color="(item.status) ? 'success' : 'grey lighten-2'">mdi-circle</v-icon>
          </template> 

          <template v-slot:[`item.action`]="{ item }" v-if="permissions.create || permissions.update || permissions.delete || permissions.sendMessage">
              <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                      <v-icon v-on="on" class="superTable__table__item__action">mdi-dots-vertical</v-icon>
                  </template>
                  <v-list class="pa-0">
                      <v-list-item @click="editItem(item.id)" v-if="permissions.update">
                          <v-list-item-title>
                              <v-icon>mdi-pencil</v-icon> {{ $t('actions.edit') }}
                          </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="$emit('send-message', item)" v-if="permissions.sendMessage && item.status">
                          <v-list-item-title>
                              <v-icon>mdi-message-text-outline</v-icon> {{ $t('modules.messaging.template.areaTemplates.sendMessage.button') }}
                          </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="duplicateItem(item.id)" v-if="permissions.create">
                          <v-list-item-title>
                              <v-icon>mdi-checkbox-multiple-blank</v-icon> {{ $t('actions.duplicate') }}
                          </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="deleteItem(item.id)" v-if="permissions.delete">
                          <v-list-item-title>
                              <v-icon>mdi-delete</v-icon> {{ $t('actions.delete') }}
                          </v-list-item-title>
                      </v-list-item>
                  </v-list>
              </v-menu>
          </template>
        </v-data-table>
        <v-divider class="mt-4 mb-8"></v-divider>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col sm="3">
        <span
          class="caption d-inline-block"
        >{{ itemsCount.startItem + ' - ' + itemsCount.endItem + ' de ' + itemsCount.totalItems }}</span>
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPageAvailable"
          :placeholder="itemsPerPage.toString()"
          outlined
          class="superTable__paginationSelect d-inline-block ml-4"
          @change="$emit('lengthPaginationChange', itemsPerPage)"
        ></v-select>
      </v-col>
      <v-col sm="6" class="text-center">
        <v-pagination 
        v-model="page" 
        :length="pageCount" 
        class="superTable__pagination"
        @input="$emit('inputPagination', $event)"
        ></v-pagination>
      </v-col>
      <v-col sm="3" align="right">
        <v-text-field
          v-model.number="goToPage"
          :max="pageCount"
          @blur="changePage"
          outlined
          class="superTable__paginationInput d-inline-block mr-4"
        ></v-text-field>
        <span class="caption d-inline-block">{{ $t('actions.goToPage') }}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="sass" scoped>
.v-expansion-panels
    .v-expansion-panel-content
        padding-left: 10px
        padding-bottom: 0px
        padding-right: 16px
.text-muted
    font-size: 14px
    color: #707070
</style>

<script>

export default {
  name: 'AreaMessagesTable',
  components:{
  },
  props: {
    data: Array,
    sections: Array,
    headers: Array,
    clearSelected: String,
    permissions: {create: false, update: false, delete: false, sendMessage: false},
    sortBy: String,
    sortDesc: Boolean,
    pageCount: {
      type: Number,
      default: 1,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalItems: Number,
  },
  data () {    
    return {
      search: '',
      itemsPerPage: 20,
      itemsPerPageAvailable: [20, 50, 100, 200],
      goToPage: 1,
      timeout: null,
    }
  },
methods: {
    keyup() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchAction();
        clearTimeout(this.timeout);
      }, 1000);
    },
    searchAction() {
      this.$emit('searchAction', this.search);
    },
    changePage() {
      if (this.goToPage > this.pageCount) {
        this.goToPage = this.page;
      } else {
        this.$emit('inputPagination', this.goToPage);
      }
    },
    editItem (id) {
      this.$emit('updateData', id);
    },
    deleteItem (id) {
      this.$emit('deleteData', id);
    },
    duplicateItem (id) {
      this.$emit('duplicateData', id);
    }
  },

  watch: {
    page(val) {
      if (val > this.pageCount) this.page = this.pageCount;
      if (val < 1) this.page = 1;
      if (this.page !== this.goToPage) this.goToPage = this.page;
    },
  },

  computed: {
    itemsCount() {
      const counter = {
        totalItems: this.totalItems,
        startItem: this.page * this.itemsPerPage - this.itemsPerPage + 1,
        endItem: this.page * this.itemsPerPage,
      };

      if (counter.endItem > this.totalItems) {
        counter.endItem = this.totalItems;
      }

      return counter;
    },
  },
};
</script>
